// Navbar.js
import React from 'react';
import { useAuth } from  '../AuthContext'
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
  const { isAuthenticated, userRole, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  console.log('Auth State:', { isAuthenticated, userRole }); 


  return (
    <header className="flex justify-between items-center p-4 bg-white">
      <div className="text-purple-800 text-3xl font-bold">
        <h1 className="text-5xl font-bold text-purple-600 mb-6" style={{ color: '#8A3FFC' }}>
          <a href="/">Reserve Place AI</a>
        </h1>
      </div>

      <nav className="flex space-x-8 text-purple-800 text-xl">
        {!isAuthenticated && (
          <>
            <a href="/signup" className="hover:text-purple-600">Login</a>
            <a href="/packages" className="hover:text-purple-600">Intelligent Event Packages</a>
            <a href="/rfp" className="hover:text-purple-600">Centralized RFP</a>
            <a href="/iplanner" className="hover:text-purple-600">Personal Event Planner</a>
            <a href="/contact" className="hover:text-purple-600">Contact Us</a>
          </>
        )}
        
        {isAuthenticated && (
          <>
            <a href="/chat" className="hover:text-purple-600">Chat</a>
            <a href="/ask" className="hover:text-purple-600">Ask</a>
            <a href="/quote" className="hover:text-purple-600">Quote</a>
            <a href="/history" className="hover:text-purple-600">History</a>
            <button onClick={logout} className="hover:text-purple-600">Logout</button>
          </>
        )}
        

      </nav>
    </header>
  );
};

export default Navbar;

// const Navbar = () => {
//   return (
//     <nav className="navbar navbar-expand-lg navbar-light bg-light">
//       <div className="container-fluid">
//       <Link className="navbar-brand d-flex align-items-center" to="/">
//           <img 
//             src="/images/venue.png" 
//             alt="VenueApp Logo" 
//             style={{ width: "40px", marginRight: "10px" }} // Adjust the size and spacing as needed
//           />
//           VenueApp
//         </Link>
//         <button
//           className="navbar-toggler"
//           type="button"
//           data-bs-toggle="collapse"
//           data-bs-target="#navbarNav"
//           aria-controls="navbarNav"
//           aria-expanded="false"
//           aria-label="Toggle navigation"
//         >
//           <span className="navbar-toggler-icon"></span>
//         </button>
//         <div className="collapse navbar-collapse" id="navbarNav">
//           <ul className="navbar-nav">
//             <li className="nav-item">
//               <Link className="nav-link active" aria-current="page" to="/">Home</Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/venue">Venue</Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/venue_prices">Venue Prices</Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/venue_features">Venue Features</Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/venue_spaces">Venue Spaces</Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/venue_space_prices">Venue Space Prices</Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/venue_space_layouts">Venue Space Layouts</Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/venue_space_features">Venue Space Features</Link>
//             </li>
//             <li class="nav-item dropdown">
//               <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
//                 Content Management
//               </a>
//               <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
//                 <li><Link className="dropdown-item " to="/types">Types</Link></li>
//                 <li><Link className="dropdown-item " to="/amenities">Amenities</Link></li>
                
//               </ul>
//             </li>
//             <li className="nav-item">
//               {/* <Link className="nav-link" to="/contact">Contact</Link> */}
//             </li>
//           </ul>
//         </div>
//       </div>
//     </nav>
//   );
// };

//export default Navbar;
